import Style from "ol/style/Style";
import { None } from "../../../../misc/option";
export class BaseStyle {
    constructor() {
        this.name = 'base';
        this.alt = false;
        this.mode = '';
    }
    style_function(id, c_fn, h_fn, ignored = None.instance()) {
        return (f) => new Style();
    }
}
